<template>
  <v-row>
    <v-col
      class="custom-bg custom-border ma-3 px-4 pt-4"
      lg="5"
      v-for="(sqItem, index) in sq5gResult.location"
      :key="index"
    >
      <p class="font-weight-bold">
        SQ Address:
        {{
          setSqAddress(sqItem.sqAddress ? sqItem.sqAddress : sqItem.SQAddress)
        }}
      </p>
      <p class="font-weight-bold">SQ ID: {{ setSqId }}</p>
      <div v-if="sqItem.mobileQualification">
        <v-list
          dense
          class="custom-bg py-0"
          v-for="(
            item, subIndex
          ) in sqItem.mobileQualification.serviceSpecCharacteristics.filter(
            (x) => x.name === 'SectorID' || x.name === '5G_FWA'
          )"
          :key="subIndex"
        >
          <v-list-item
            ><p>
              <v-icon :color="setColor(item.value)">{{
                setIcon(item.value)
              }}</v-icon>
              {{ `${item.name}:` }}<span class="pl-2"> {{ item.value }}</span>
            </p></v-list-item
          >
        </v-list>
      </div>
      <div v-else>
        <v-list dense class="custom-bg py-0">
          <v-list-item
            ><p>
              <v-icon color="error">mdi-close-thick</v-icon>
              No Available Service
            </p></v-list-item
          >
        </v-list>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Qualification5G",
  props: {
    orderData: {
      type: Object,
      required: false,
    },
    sqResponse: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    available: ["true", "Y", "1"],
    notAvailable: ["false", "N", "0", ""],
  }),
  mounted() {
    let vm = this;
    if (vm.isOriginal) {
      if (vm.orderData.orderType === "5G") {
        let newItem = vm.sqResponse;
        vm.set5gSqResult({
          sqId: newItem.Body.queryServiceQualificationResponse.SQResults.SQID,
          location:
            newItem.Body.queryServiceQualificationResponse.SQResults.location,
        });
      }
    }
  },
  methods: {
    setIcon(item) {
      let vm = this;
      if (vm.notAvailable.some((x) => x.toLowerCase() === item.toLowerCase()))
        return "mdi-close-thick";
      else return "mdi-check-bold";
    },
    setColor(item) {
      let vm = this;
      if (vm.notAvailable.some((x) => x.toLowerCase() === item.toLowerCase()))
        return "error";
      else return "success";
    },
    setSqAddress(item) {
      let vm = this;
      if (vm.sq5gResult.location !== undefined) {
        return `${item.streetNumber} ${item.streetName} ${item.streetType}, ${item.suburb}, ${item.state} ${item.postCode}`;
      } else return "";
    },
  },
  computed: {
    setSqId() {
      let vm = this;
      if (vm.sq5gResult !== null) {
        return vm.sq5gResult.sqid;
      } else return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-bg {
  background-color: #f4f4f7;
}

.custom-border {
  border-radius: 4px;
}

.hide {
  color: #f4f4f7;
}
</style>